import { gql } from 'graphql-request';

export const getArticle = gql`
  query GetArticle($slug: String!) {
    getArticle(slug: $slug) {
      id
      date
      title
      slug
      chinese
      base
      json
      image
      sound
      url
      perLanguage {
        id
        published
        premium
        calculatedSkill
        sound
        silences
        language
        displaySkill {
          level
          label
          value
          languageId
        }
        sentence {
          id
          sentence
          json
          language
          translation {
            translation
            language
          }
          rule {
            id
            rule {
              id
              name
            }
          }
        }
        description
      }
    }
  }
`;

export const getCategories = gql`
  query GetCategories($taxonId: Int) {
    getCategories(taxonId: $taxonId) {
      id
      name
      url
      taxon {
        id
        name
        url
      }
      collections {
        id
        title
        slug
        image
        date
        category
      }
    }
  }
`;

export const getBasicCategories = gql`
  query GetBasicCategories($taxonId: Int) {
    getCategories(taxonId: $taxonId) {
      id
      name
      taxon {
        id
      }
    }
  }
`;

export const getTaxons = gql`
  query GetTaxons {
    getTaxons {
      id
      name
      url
    }
  }
`;

export const getArticles = gql`
  query GetArticles(
    $published: Boolean
    $langCode: String
    $ordering: String
    $category: [Int!]
    $taxon: [Int!]
    $startDate: String
    $endDate: String
    $displaySkill: [Int!]
    $premium: Boolean
  ) {
    getArticles(
      published: $published
      langCode: $langCode
      ordering: $ordering
      category: $category
      taxon: $taxon
      startDate: $startDate
      endDate: $endDate
      displaySkill: $displaySkill
      premium: $premium
    ) {
      id
      date
      title
      slug
      image
      url
      perLanguage {
        id
        published
        premium
        calculatedSkill
        language
        displaySkill {
          level
          label
          value
          languageId
        }
      }
    }
  }
`;

export const getPerLanguage = gql`
  query GetPerLanguage($articleId: Int!) {
    getPerLanguage(articleId: $articleId) {
      id
      published
      premium
      calculatedSkill
      sound
      silences
      language
      displaySkill {
        level
        label
        value
        languageId
      }
      sentence {
        id
        sentence
        json
        language
        translation {
          translation
          language
        }
      }
      description
    }
  }
`;

export const getArticleSentences = gql`
  query GetArticleSentences($perLanguageId: Int, $langCode: String) {
    getArticleSentences(perLanguageId: $perLanguageId, langCode: $langCode) {
      id
      sentence
      json
      language
      translation {
        translation
        language
      }
      rule {
        id
        rule {
          id
          name
        }
      }
    }
  }
`;

export const getTranslations = gql`
  query GetTranslations {
    getTranslations {
      translation
      sentence {
        id
        sentence
      }
      language
    }
  }
`;

export const createArticle = gql`
  mutation CreateArticle($input: PageInput!) {
    createArticle(input: $input) {
      id
      date
      title
      slug
      chinese
      base
      json
      image
      sound
      url
    }
  }
`;

export const updateArticle = gql`
  mutation UpdateArticle($id: Int!, $input: PageInput!) {
    updateArticle(id: $id, input: $input) {
      id
      date
      title
      slug
      chinese
      base
      json
      image
      sound
      url
    }
  }
`;

export const deleteArticle = gql`
  mutation DeleteArticle($id: Int!) {
    deleteArticle(id: $id)
  }
`;

export const createPerLanguage = gql`
  mutation CreatePerLanguage($input: PerLanguageInput!) {
    createPerLanguage(input: $input) {
      id
      published
      premium
      calculatedSkill
      sound
      silences
      language
      displaySkill {
        level
        label
        value
        languageId
      }
    }
  }
`;

export const createSentence = gql`
  mutation CreateSentence($input: ArticleSentenceInput!) {
    createSentence(input: $input) {
      id
      sentence
      json
      language
    }
  }
`;

export const createTranslation = gql`
  mutation CreateTranslation($input: TranslationInput!) {
    createTranslation(input: $input) {
      translation
      sentence {
        id
        sentence
      }
      language
    }
  }
`;

export const randomSentences = gql`
  query RandomSentences($number: Int = 10) {
    randomSentences(number: $number) {
      id
      sentence
      json
      language
      translation {
        translation
        language
      }
      rule {
        id
        rule {
          id
          name
        }
      }
    }
  }
`;
